<div class="ip-dialog-wrap">
  <button class="ip-close-btn" type="button" (click)="close()" aria-label="Close image preview">
    <ion-icon name="close-outline"></ion-icon>
  </button>

  <div class="ip-toolbar">
    <button class="ip-tool-btn" type="button" (click)="zoomOut()" aria-label="Zoom out">-</button>
    <button class="ip-tool-btn" type="button" (click)="resetZoom()" aria-label="Reset zoom">100%</button>
    <button class="ip-tool-btn" type="button" (click)="zoomIn()" aria-label="Zoom in">+</button>
  </div>

  <div class="ip-image-stage" (wheel)="onWheel($event)">
    <img
      class="ip-image"
      [src]="data?.imageUrl || '/assets/no-image.jpg'"
      alt="Image preview"
      [style.transform]="'scale(' + zoom + ')'"
      (error)="$any($event.target).src='/assets/no-image.jpg'"
    />
  </div>
</div>
